/*
 * @Author: your name
 * @Date: 2021-08-23 14:28:28
 * @LastEditTime: 2021-08-23 15:11:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \contingency-manage\src\directives\index.js
 */
const contexts = require.context('.', false, /\.js$/);

export default function install(app) {
  contexts.keys().forEach(component => {
    if (!component.includes('index.js')) {
      const path = component.replace(/(\.\/|\/index|\.js)/g, '');
      const len = path.split('/').length;
      const name = path.split('/')[len - 1];
      // 使用内置的组件名称 进行全局组件注册
      console.log(contexts(component).default, 6666666);
      app.directive(name, contexts(component).default);
    }
  });
};